import { create } from 'zustand';

type PopupSize = 'sm' | 'md' | 'lg';

type PopupState = {
  isPopup: boolean;
  popupContent: React.ReactNode;
  popupFooter?: React.ReactNode;
  popupTitle: string;
  popupSize: PopupSize;
  setPopup: (
    title?: string,
    content?: React.ReactNode,
    popupFooter?: React.ReactNode,
    size?: PopupSize
  ) => void;
};

const usePopupStore = create<PopupState>((set) => ({
  isPopup: false,
  popupContent: null,
  popupTitle: '',
  popupFooter: null,
  popupSize: 'md',
  setPopup: (title = '', content, footer, size = 'md') =>
    set(() => ({
      isPopup: !!content,
      popupContent: content,
      popupFooter: footer,
      popupTitle: title,
      popupSize: size,
    })),
}));

export default usePopupStore;
